
import IconClose from '@svg/IconClose.svg'
import IconCompress from '@svg/Icon_Compress.svg'
import IconImage from '@svg/Icon_Image.svg'
import IconStack from '@svg/IconStack.svg'
import { Component, Prop, Vue } from 'vue-property-decorator'

type ExportFormat = 'zip' | 'astc' | 'thumbnail'

@Component({
  components: {
    'icon-close': IconClose,
    'icon-compress': IconCompress,
    'icon-image': IconImage,
    'icon-stack': IconStack,
  },
})
export default class ExportJigModalVue extends Vue {
  @Prop({ type: String, default: '' })
  public compressedThumbnailUrl!: string

  @Prop({ type: Boolean, default: false })
  public isProcessing!: boolean

  private dialogVisible: boolean = false
  private selectedFormat: ExportFormat = 'zip'

  private get confirmLabel(): string {
    if (this.selectedFormat === 'zip') return 'Download .zip'
    if (this.selectedFormat === 'astc') return 'Download .astc'
    return 'Download .png'
  }

  public show() {
    this.selectedFormat = 'zip'
    this.dialogVisible = true
  }

  public close() {
    this.dialogVisible = false
  }

  private onConfirm() {
    if (this.selectedFormat === 'zip') {
      this.$emit('on-export-zip')
    } else if (this.selectedFormat === 'astc') {
      window.open(this.compressedThumbnailUrl, '_blank')
      this.close()
    } else {
      this.$emit('on-export-thumbnail')
    }
  }
}
